/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import { Formik } from "formik";
import * as Yup from "yup";
import Grid from "@mui/material/Grid";

import {
  Input,
  AutoSaveField as Field,
  SelectAutocomplete
} from "../../../../../../../../components/Form";
import {
  SPECIAL_CHARACTERS_REGEX,
  checkIsTrimmed,
  NUMBER_REGEX,
  ALPHANUMERIC_REGEX
} from "../../../../../../../../utils/validation";
import {
  getInvalidMessage,
  getNotTrimmedMessage
} from "../../../../../../../../utils/getValidationMessage";
import { FormContainer } from "../../styled";
import { ScrollToError } from "components/ScrollToError";
// Removed duplicate import as it is consolidated above

const primaryBorrowerNonUAESchema = () =>
  Yup.object().shape({
    lenderOrBankname: Yup.string()
      .max(50, "Maximum 50 characters allowed")
      .matches(SPECIAL_CHARACTERS_REGEX, getInvalidMessage("Name of the Lender/ Bank Name"))
      .test(
        "space validation",
        getNotTrimmedMessage("Name of the Lender/ Bank Name"),
        checkIsTrimmed
      ),
    iban: Yup.string()
      //.required(getRequiredMessage("IBAN"))
      .matches(ALPHANUMERIC_REGEX, getInvalidMessage("IBAN"))
      .max(23, "Maximum 23 characters allowed"),
    loanFacilityType: Yup.string()
      .max(50, "Maximum 50 characters allowed")
      .matches(SPECIAL_CHARACTERS_REGEX, getInvalidMessage("Finance/Facility Type")),
    loanFacilityAmount: Yup.string()
      .max(13, "Maximum 13 characters allowed")
      .matches(NUMBER_REGEX, getInvalidMessage("Finance/Facility Amount")),
    currency: Yup.string().max(3, "Maximum 3 characters allowed")
  });

const initialValues = {
  lenderOrBankname: "",
  iban: "",
  loanFacilityType: "",
  loanFacilityAmount: "",
  currency: ""
};
export const PrimaryBorrowerNonUAE = ({ handleContinue, index }) => {
  const basePath = `roProspect.organizationInfoRO.otherBankPrimaryBorrowerRelationship.outsideUAEBankRelationship[${index}]`;
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={primaryBorrowerNonUAESchema}
      onSubmit={handleContinue}
      validateOnChange={false}
    >
      {({ values }) => {
        return (
          <FormContainer>
            <ScrollToError />
            <Grid container spacing={3}>
              <Grid item sm={6} xs={12}>
                <Field
                  name="lenderOrBankname"
                  path={`${basePath}.bankName`}
                  label="Name of the Lender/ Bank Name"
                  placeholder="Name of the Lender/ Bank Name"
                  component={Input}
                  InputProps={{
                    inputProps: { tabIndex: 0 }
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Field
                  name="iban"
                  path={`${basePath}.iban`}
                  label="IBAN"
                  placeholder="IBAN"
                  component={Input}
                  InputProps={{
                    inputProps: { tabIndex: 0, maxLength: 23 }
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Field
                  name="loanFacilityType"
                  path={`${basePath}.loanType`}
                  label="Finance/Facility Type"
                  placeholder="Finance/Facility Type"
                  component={Input}
                  InputProps={{
                    inputProps: { tabIndex: 0 }
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Field
                  name="loanFacilityAmount"
                  path={`${basePath}.loanAmount`}
                  label="Finance/Facility Amount"
                  placeholder="Finance/Facility Amount"
                  component={Input}
                  InputProps={{
                    inputProps: { tabIndex: 0 }
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Field
                  name="currency"
                  path={`${basePath}.currency`}
                  label="Currency"
                  placeholder="Currency"
                  InputProps={{
                    inputProps: { tabIndex: 0 }
                  }}
                  component={SelectAutocomplete}
                  datalistId="accountCurrencies"
                />
              </Grid>
            </Grid>
          </FormContainer>
        );
      }}
    </Formik>
  );
};

PrimaryBorrowerNonUAE.propTypes = {
  /**
   * Function to handle form submission and continue to next step
   */
  handleContinue: PropTypes.func.isRequired,

  /**
   * Index of the bank relationship in the array, used for path construction
   */
  index: PropTypes.number.isRequired
};
